export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    function initialize(mn, mlat, mlng, mmark, murl) {
      // Create an array of styles.
      var styles = [
        {
          stylers: [
            {
              hue: "#ff0000",
            },
            {
              saturation: -100,
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [
            {
              lightness: 100,
            },
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels",
          stylers: [
            {
              visibility: "on",
            },
          ],
        },
      ];

      // Create a new StyledMapType object, passing it the array of styles,
      // as well as the name to be displayed on the map type control.
      var styledMap = new google.maps.StyledMapType(styles, {
        name: mn,
      });

      // Create a map object, and include the MapTypeId to add
      // to the map type control.
      var gpLatLng = new google.maps.LatLng(mlat, mlng); // Update this lat lng based on address
      var mapOptions = {
        zoom: 17,
        center: gpLatLng,
        mapTypeControlOptions: {
          mapTypeIds: [google.maps.MapTypeId.ROADMAP, "map_style"],
        },
      };
      var map = new google.maps.Map(
        document.getElementById("map-canvas"),
        mapOptions
      );
      var marker = new google.maps.Marker({
        position: gpLatLng,
        map: map,
        icon: marker_base + mmark, // marker_base is defined in lib/scripts.php
        url: murl, // Update this google map address
      });
      //Associate the styled map with the MapTypeId and set it to display.
      map.mapTypes.set("map_style", styledMap);
      map.setMapTypeId("map_style");
      //Add marker event listener
      google.maps.event.addListener(marker, "click", function () {
        window.location.href = marker.url;
      });
    }

    var map_name = "The Institute of Performance Nutrition",
      map_lat = 51.51856,
      map_lng = -0.142218,
      map_marker = "gp-marker.png",
      map_url = "https://goo.gl/maps/NEuPieRMMXbVQFpZ8";
    initialize(map_name, map_lat, map_lng, map_marker, map_url);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js